import { Link } from "react-router-dom";
import { Heart, ArrowUpRight } from "lucide-react";

// Aliança de Amor progress card: how many approved members registered theirs.
export const AliancaCard = ({ alianca }) => (
  <Link
    to="/admin/membros?alianca=without"
    className="mt-6 block bg-white border border-[hsl(var(--border))] hover:border-[hsl(var(--accent))] transition-colors p-5"
    data-testid="dashboard-alianca-card"
  >
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-start gap-3 min-w-0">
        <Heart className="h-5 w-5 text-[hsl(var(--accent))] mt-0.5 flex-shrink-0" />
        <div className="min-w-0">
          <div className="overline">Aliança de Amor</div>
          <h3 className="display-heading text-2xl mt-1 tabular-nums">
            <span data-testid="alianca-with">{alianca.with}</span>
            <span className="text-[hsl(var(--muted-foreground))] text-lg"> de {alianca.total}</span>
          </h3>
          <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
            sócios aprovados têm Aliança registada
            {alianca.without > 0 && (
              <> · <span className="text-[hsl(var(--primary))]" data-testid="alianca-without">{alianca.without} ainda por preencher</span></>
            )}
          </p>
        </div>
      </div>
      <div className="hidden sm:inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-[hsl(var(--primary))]">
        Ver pendentes <ArrowUpRight className="h-3.5 w-3.5" />
      </div>
    </div>
    {/* Progress bar */}
    <div className="mt-4 h-2 bg-[hsl(var(--secondary))]">
      <div
        className="h-full bg-[hsl(var(--accent))] transition-all"
        style={{ width: `${Math.round((alianca.with / alianca.total) * 100)}%` }}
      />
    </div>
  </Link>
);
